import React from 'react';
import PropTypes from 'prop-types';
import {
	map
} from 'lodash';
import {
	Panel
} from 'react-bootstrap';
import ScrollableAnchor from 'react-scrollable-anchor'
import TableUtils from '../../../../../utils/TableUtils';
import TablePlain from '../../../../../components/table-plain/TablePlain';
import StrongText from '../../../../../components/strong-text/StrongText';
import moment from 'moment';
import TableSueldosPagos from './panel-datos-empresa/components/TableSueldosPagos';
import TableEmpleadosAportes from '../../../../../components/table-empleados-aportes/TableEmpleadosAportes';
import PermissionChecker from '../../../../../components/permission-checker/PermissionChecker';
import lstrings from '../../../../../utils/LStrings';
import 'react-bootstrap-table/css/react-bootstrap-table.css';

class PanelDatosEmpresa extends React.Component {

	onRequestInfo = (infoKey, infoTitle) => {
		this.props.onRequestInfo("Datos de la empresa", infoTitle);
	}

	render() {
		let titulo = <h4><i className="fa fa-briefcase"></i>  Datos de la empresa</h4>;

		let columnsAmountEmployees = [];
		let year = moment().get('y') - 6;
		for (let x = year; x <= (year + 5); x++) {
			columnsAmountEmployees.push(`${x}`);
		}
		columnsAmountEmployees.push('Actual');

		let empresa = this.props.info.empresa.datos;
		return (
			<ScrollableAnchor id={'panel-datosempresa'}>
				<Panel collapsible defaultExpanded header={titulo}>

					<TablePlain title={'General'}
						columns={[
							lstrings.razonsocial,
							lstrings.cuit,
							lstrings.fechaconstitucion,
							lstrings.fecha_cese
						]}
						rows={[(<tr key={0}>
							<td>{TableUtils.stringFormat(empresa.razon)}</td>
							<td>{TableUtils.stringFormat(empresa.cuit)}</td>
							<td>{TableUtils.dateFormat(empresa.constitucion)}</td>
							<td><StrongText text={TableUtils.dateFormat(empresa.cese)} /></td>
						</tr>)]} />

					<PermissionChecker
						infoKey='actividad'
						infoTitle='Actividades'
						data={this.props.info.actividad}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						{
							this.props.info.actividad &&
							<TablePlain
								columns={[
									lstrings.codigo,
									lstrings.actividad,
								]}
								rows={map(this.props.info.actividad.datos, (item, ix) =>
									<tr key={ix}>
										<td>{item.ciiu}</td>
										<td>{item.descripcion}</td>
									</tr>
								)}
							/>
						}
					</PermissionChecker>

					<TablePlain
						title={lstrings.domiciliofiscal_title}
						fixed={true} showCount
						columns={[
							lstrings.ubicacion,
							lstrings.codigoPostal,
							lstrings.localidad,
							lstrings.provincia,
						]}
						rows={[(
							<tr key={0}>
								<td>{TableUtils.stringFormat(empresa.direccion)}</td>
								<td>{TableUtils.stringFormat(empresa.cp)}</td>
								<td>{TableUtils.stringFormat(empresa.localidad)}</td>
								<td>{TableUtils.stringFormat(empresa.provincia)}</td>
							</tr>
						)]}
					/>

					<PermissionChecker
						infoKey='domAlternativos'
						infoTitle={lstrings.otrosdomicilios_title}
						data={this.props.info.domAlternativos}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						{
							this.props.info.domAlternativos &&
							<TablePlain
								fixed={true}
								columns={[
									lstrings.ubicacion,
									lstrings.codigoPostal,
									lstrings.localidad,
									lstrings.provincia,
								]}
								rows={map(this.props.info.domAlternativos.datos, (item, ix) =>
									<tr key={ix}>
										<td>{item.domicilioAlt}</td>
										<td>{item.cpAlt}</td>
										<td>{item.localidadAlt}</td>
										<td>{item.provinciaAlt}</td>
									</tr>
								)}
							/>
						}
					</PermissionChecker>

					<PermissionChecker
						infoKey='situacionFiscal'
						infoTitle={lstrings.situacionfiscal_title}
						data={this.props.info.situacionFiscal}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						<TablePlain
							fixed={true}
							columns={[
								lstrings.tipo,
								lstrings.ganancias,
								lstrings.iva,
								lstrings.integrasociedades,
								lstrings.fecha,
							]}
							rows={this.props.info.situacionFiscal == null ? [] : [
								<tr key={0}>
									<td>{this.props.info.situacionFiscal.datos.tipodato}</td>
									<td>{this.props.info.situacionFiscal.datos.ganancias}</td>
									<td>{this.props.info.situacionFiscal.datos.iva}</td>
									<td>{this.props.info.situacionFiscal.datos.integranteSoc}</td>
									<td>{TableUtils.dateFormat(this.props.info.situacionFiscal.datos.fecha)}</td>
								</tr>
							]}
						/>
					</PermissionChecker>

					<PermissionChecker
						infoKey='empAportes'
						infoTitle={lstrings.emp_aportes_title}
						data={this.props.info.empAportes}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels} noCount noMoreBtn
					>
						<TableEmpleadosAportes
							data={this.props.info.empAportes}
							infoKey='empAportes'
							infoTitle={lstrings.emp_aportes_title}
							onRequestInfo={this.onRequestInfo}
							rangoIngresos={this.props.rangoIngresos}
						/>
					</PermissionChecker>

					<PermissionChecker
						infoKey='sueldos'
						infoTitle={lstrings.sueldospagos_title}
						data={this.props.info.sueldos}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						<TableSueldosPagos
							data={this.props.info.sueldos}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.props.hidePanels}
						/>
					</PermissionChecker>

					<PermissionChecker
						infoKey='domAportes'
						infoTitle={lstrings.domesticosEmpleadosTitle}
						data={this.props.info.domAportes}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						{
							this.props.info.domAportes &&
							<TablePlain
								columns={[
									lstrings.estado,
									lstrings.empleado,
									lstrings.cuit,
									lstrings.alta,
									lstrings.baja,
									lstrings.modoliquidacion,
									lstrings.sueldopactadoinicio,
								]}
								rows={map(this.props.info.domAportes.datos, (item, ix) =>
									<tr key={ix}>
										<td>{item.empDomestico.estado}</td>
										<td>{item.empDomestico.nombre}</td>
										<td>{TableUtils.cuitFormat(item.empDomestico.cuilEmple)}</td>
										<td>{TableUtils.dateFormat(item.empDomestico.alta)}</td>
										<td>{TableUtils.dateFormat(item.empDomestico.baja)}</td>
										<td>{item.empDomestico.modoliquida}</td>
										<td>{TableUtils.ARSFormat(item.empDomestico.sueldo)}</td>
									</tr>
								)}
							/>
						}
					</PermissionChecker>

					<PermissionChecker
						infoKey='seguridadSocial'
						infoTitle={lstrings.seguridadsocial_title}
						data={this.props.info.seguridadSocial}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						{
							this.props.info.seguridadSocial &&
							<TablePlain
								columns={[
									lstrings.periodo,
									lstrings.seguridadsocialaportes,
									lstrings.seguridadsocialcontribuciones,
									lstrings.seguridadsocialretenciones,
									lstrings.obrasocialaportes,
									lstrings.obrasocialcontribuciones,
									lstrings.obrasocialretenciones,
								]}
								rows={map(this.props.info.seguridadSocial.datos, (item, ix) =>
									<tr key={ix}>
										<td>{moment(item.periodo).year()}</td>
										<td>{item.segSocialAportes}</td>
										<td>{item.segSocialContribu}</td>
										<td>{item.segSocialRetencion}</td>
										<td>{item.obSocialAportes}</td>
										<td>{item.obSocialContribu}</td>
										<td>{item.obSocialRetencion}</td>
									</tr>
								)}
							/>
						}
					</PermissionChecker>

					<PermissionChecker
						infoKey='art'
						infoTitle={lstrings.coberturaart_title}
						data={this.props.info.art}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						{
							this.props.info.art &&
							<TablePlain
								columns={[
									lstrings.artVigente,
									lstrings.variable,
									lstrings.sumaFija,
									lstrings.valorContratoAprox,
									lstrings.capitasDeclaradas,
									lstrings.masaSalarialDeclarada,
									lstrings.periodoArt,
									lstrings.fechaPresentacionArt,
								]}
								rows={map(this.props.info.art.datos, (item, ix) =>
									<tr key={ix}>
										<td>{TableUtils.stringFormat(item.artVigente)}</td>
										<td>{item.variable}</td>
										<td>{item.sumaFija}</td>
										<td>{TableUtils.ARSFormat(item.valorContratoAprox, false, true)}</td>
										<td>{item.capitasDeclaradas}</td>
										<td>{TableUtils.ARSFormat(item.masaSalarialDeclarada, false, true)}</td>
										<td>{TableUtils.dateFormat(item.fechaInicio)}</td>
										<td>{TableUtils.dateFormat(item.vigencia)}</td>
									</tr>
								)}
							/>
						}
					</PermissionChecker>

				</Panel>
			</ScrollableAnchor>
		);
	}
}

PanelDatosEmpresa.propTypes = {
	info: PropTypes.object.isRequired,
	onRequestInfo: PropTypes.func,
	hidePanels: PropTypes.any,
	rangoIngresos: PropTypes.object
}

export default PanelDatosEmpresa;



// WEBPACK FOOTER //
// ./src/scenes/empresas/components/empresas-detalle/components/PanelDatosEmpresa.js